// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cd82aa00","455":"d24c741d","977":"b69fb76a"}[chunkId] + ".chunk.js";
};